<div class="p-3 md:p-5">
  <div class="notifications-container">
    <div class="flex flex-column gap-1">
      <div class="display-xs-semibold text-gray-900">Obaveštenja</div>
      <div class="text-md-regular text-gray-600">
        Obaveštenja vezana za vaše naloge i aktivnosti.
      </div>
    </div>

    <div class="notifications-content">
      <div class="flex flex-column align-items-start gap-2 md:flex-row md:justify-content-between md:align-items-center md:gap-3">
        <p-tabs
          class="transparent notification-tabs"
          [value]="activeTab()"
          (valueChange)="onTabChange($event)"
        >
          <p-tablist>
            <p-tab [value]="0">
              <div class="flex align-items-center gap-2">
                <app-bell-02
                  [stroke]="activeTab() === 0 ? '#181D27' : '#7E838F'"
                  width="20px"
                  height="20px"
                ></app-bell-02>
                <span class="text-sm-semibold">Sva obaveštenja</span>
              </div>
            </p-tab>
            <p-tab [value]="1">
              <div class="flex align-items-center gap-2">
                <app-eye-off
                  [stroke]="activeTab() === 1 ? '#181D27' : '#7E838F'"
                  width="20px"
                  height="20px"
                ></app-eye-off>
                <span class="text-sm-semibold">Nepročitana</span>
                @if (notificationService.unreadCount() > 0) {
                  <span class="unread-badge text-xs-medium">{{ notificationService.unreadCount() }}</span>
                }
              </div>
            </p-tab>
          </p-tablist>
        </p-tabs>

        @if (notificationService.unreadCount() > 0) {
          <button
            type="button"
            class="mark-all-btn"
            (click)="markAllAsRead()"
          >
            <span class="mark-all-btn__icon">
              <app-check stroke="#2970FF" width="11px" height="8px"></app-check>
            </span>
            <span class="text-sm-semibold">Označi sve kao pročitano</span>
          </button>
        }
      </div>

      <div class="notifications-list">
        @for (item of items(); track item.id) {
          <div class="notification-row" [class.unread]="item.unread" (click)="markAsRead(item.id)">
            <div class="notification-icon">
              <app-dynamic-icon
                [iconComponent]="iconFor(item.icon)"
                stroke="#414651"
                width="20px"
                height="20px"
              ></app-dynamic-icon>
            </div>

            <div class="notification-body">
              <div class="notification-text">
                <div class="flex align-items-center justify-content-between gap-2">
                  <div
                    class="text-sm-semibold"
                    [class.text-gray-900]="item.unread"
                    [class.text-gray-700]="!item.unread"
                  >
                    {{ item.title }}
                  </div>
                  @if (item.unread) {
                    <span class="unread-dot"></span>
                  }
                </div>
                <div class="text-sm-regular text-gray-600">
                  {{ item.description }}
                </div>
              </div>
              <div class="flex flex-wrap align-items-center notification-actions">
                <span class="text-sm-regular text-gray-500">{{ item.timeAgo }}</span>
                @if (item.actionLabel) {
                  <button type="button" class="action-link">
                    <span class="text-sm-semibold">{{ item.actionLabel }}</span>
                    <app-chevron-right
                      class="action-link__icon"
                      stroke="#2970FF"
                      width="7px"
                      height="12px"
                    ></app-chevron-right>
                  </button>
                }
              </div>
            </div>
          </div>
        }

        @if (items().length === 0) {
          <div class="empty-state text-md-regular text-gray-500">
            {{ activeTab() === 1 ? 'Nemate novih obaveštenja.' : 'Nemate obaveštenja.' }}
          </div>
        }

        @if (paginatedData().totalCount > paginatedData().pageSize) {
          <div class="paginator-wrap">
            <p-paginator
              [rows]="paginatedData().pageSize"
              [totalRecords]="paginatedData().totalCount"
              [first]="first()"
              (onPageChange)="onPageChange($event)"
            ></p-paginator>
          </div>
        }
      </div>
    </div>
  </div>
</div>
